import axiosQlikClient from 'api';
import axiosDBClient from 'axiosDBClient';
import {
  areas,
  EMPTY_ARRAY,
  MYVIEW_TILE_LIMIT,
  NUMBER_ZERO,
  QUERY_KEY,
  VIEW_TYPE,
} from 'constants/constants';
import { trackPromise } from 'react-promise-tracker';
import { getQlikSenseData } from 'services/qlik.service';
import { getMultiDimensionChartData } from 'services/trends.service';
import {} from 'store/auth/Authslice';
import { getCustomerData } from 'store/customer/customer-view-actions';
import { buildCardDetails, getArrayToStringArray } from 'utils/utils';
import {
  setCards,
  setDefaultCard,
  appendCards,
  appendDefaultCards,
  setImpactedCards,
  setSelectedTimePeriod,
  setTimePeriodOptions,
  setTimePeriods,
  setTotalTileCount,
} from './homeMyViewSlice';

/**
 * Gets time period data and formats it so
 * the Time Period dropdown can use it
 * also stores time period
 * store the kpi time period in the store
 * @param {*} kpiId the kpi id
 * @returns
 */
export const getTimePeriodData = (kpiId) => {
  return async (dispatch) => {
    const getTimePeriods = async () => {
      const response = await axiosDBClient.get('filter/time-period', {
        params: { kpiId },
      });

      if (response.data.error) {
        throw new Error('Could not fetch products!');
      }
      return response.data.result;
    };

    try {
      const timePeriods = await getTimePeriods();
      dispatch(setTimePeriods(timePeriods));
      const timePeriodOptions = timePeriods.map((timePeriod) => {
        return {
          label: timePeriod.timePeriodName,
          value: timePeriod.timePeriodId,
        };
      });

      dispatch(setTimePeriodOptions(timePeriodOptions));
      let exp = timePeriods.filter((tp) => tp.uXDefaultValue === 'Y')[0];
      dispatch(
        setSelectedTimePeriod({
          label: exp.timePeriodName,
          value: exp.timePeriodId,
        })
      );
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const addToMyView = async (payload) => {
  const setAddToMyView = async () => {
    const response = await axiosDBClient.post('v2/views/configure', {
      ...payload,
    });

    if (response.data.error) {
      throw new Error('Could not add data!');
    }

    return response.data;
  };

  try {
    const data = await setAddToMyView();
    return data.result;
  } catch (error) {
    console.log(error.message);
    return error.response?.data;
  }
};

export const updateMyView = async (payload) => {
  const setUpdateMyView = async () => {
    const response = await axiosDBClient.put(
      `v2/views/configure/${payload.cardId}`,
      {
        ...payload,
      }
    );

    if (response.data.error) {
      throw new Error('Could not update data!');
    }

    return response.data;
  };

  try {
    const data = await setUpdateMyView();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const deleteMyView = async (cardId, positionIndex, viewId) => {
  const setDeleteMyView = async () => {
    const response = await axiosDBClient.delete(
      `v2/views/configure/${cardId}`,
      {
        data: {
          positionIndex: positionIndex,
          viewId: viewId,
        },
      }
    );

    if (response.data.error) {
      throw new Error('Could not delete data!');
    }

    return response.data;
  };

  try {
    const data = await setDeleteMyView();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};
export const updateCardTitle = async (cardId, title, unixId) => {
  const setUpdateMyView = async () => {
    const response = await axiosDBClient.patch(
      `v2/views/configure/title/${cardId}`,
      {
        title: title,
        unixId: unixId,
      }
    );

    if (response.data.error) {
      throw new Error('Could not delete data!');
    }

    return response.data;
  };

  try {
    const data = await setUpdateMyView();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const saveReorderedTiles = async (payload, page) => {
  const setUpdateCardPositions = async () => {
    const response = await axiosDBClient.patch(
      `v2/view-list/reorder/tiles`,
      { ...payload },
      { params: { page } }
    );

    if (response.data.error) {
      throw new Error('Could not update card positions!');
    }

    return response.data;
  };

  try {
    return await setUpdateCardPositions();
  } catch (error) {
    console.log(`${error.message}`);
  }
};

export const getQlikDataForCard = async (
  expression,
  dimension,
  appId,
  limit
) => {
  try {
    return await getQlikSenseData(expression, dimension, appId, limit);
  } catch (error) {
    console.log(error.message);
  }
};

export const getImpactedCardsData = (unixId, roleId) => {
  return async (dispatch) => {
    const getImpactedCards = async () => {
      const response = await axiosDBClient.get(`impacted-cards`, {
        params: { unixId, roleId },
      });

      if (response.data.error) {
        throw new Error('Could not fetch my view data!');
      }

      return response.data;
    };

    try {
      const cards = await getImpactedCards();

      if (cards?.length === NUMBER_ZERO) {
        dispatch(setImpactedCards([]));
        return;
      } else {
        dispatch(setImpactedCards(cards));
      }
    } catch (error) {
      console.log('ERROR', error);
    }
  };
};
export const discardImpactedCardsData = (unixId, roleId) => {
  return async (dispatch) => {
    const discardImpactedCards = async () => {
      const response = await axiosDBClient.put(`impacted-cards`, {
        unixId,
        roleId,
      });

      if (response.data.error) {
        throw new Error('Could not fetch my view data!');
      }

      return response.data.data;
    };

    try {
      const cards = await discardImpactedCards();

      if (cards?.length === 0) {
        dispatch(setImpactedCards([]));
        return;
      } else {
        dispatch(setImpactedCards(cards));
      }
    } catch (error) {
      console.log('ERROR', error);
    }
  };
};
export const deleteImpactedCardWarning = async (id) => {
  const setDeleteWarning = async () => {
    const response = await axiosDBClient.patch(`impacted-cards/${id}`);

    if (response.data.error) {
      throw new Error('Could not delete warning!');
    }

    return response.data;
  };

  try {
    const data = await setDeleteWarning();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getViewCards = (params) => {
  return async (dispatch) => {
    const { roleId, viewId, viewType, offset, limit } = params;

    // Check if this is a pagination request (offset > 0)
    const isAppend = offset > NUMBER_ZERO;

    const fetchViewCards = async () => {
      const requestParams = {
        viewId,
        viewType,
        roleId,
        offset,
        limit: limit > MYVIEW_TILE_LIMIT ? MYVIEW_TILE_LIMIT : limit,
      };
      const response = await axiosDBClient.get(`v2/views`, {
        params: requestParams,
      });

      if (response?.data?.error) {
        throw new Error('Could not fetch view data!');
      }

      return response?.data?.result;
    };

    try {
      const response = await trackPromise(fetchViewCards(), areas.home);
      const { data: cards, totalSize } = response;

      if (isAppend) {
        // For append, combine existing with new cards
        const appendAction =
          viewType === VIEW_TYPE.SAMPLE ? appendDefaultCards : appendCards;
        dispatch(appendAction(cards));
      } else {
        // For initial load, replace cards
        const setAction =
          viewType === VIEW_TYPE.SAMPLE ? setDefaultCard : setCards;
        dispatch(setAction(cards));
      }

      dispatch(setTotalTileCount(totalSize));

      return response;
    } catch (error) {
      dispatch(setTotalTileCount(NUMBER_ZERO));
      console.log('ERROR', error);
      return [];
    }
  };
};

export const getPriorityCustomers = async (params) => {
  try {
    const response = await trackPromise(getCustomerData(...params), areas.home);
    if (!response) {
      throw new Error('Could not fetch priority customer data!');
    }
    return response?.result?.data;
  } catch (error) {
    console.log(error.message);
    return [];
  }
};

export const getAnalyticsData = async (
  card,
  userRestrictedRole,
  userRestrictedEcosystemt,
  restrictedProductSquad,
  priorityCustomers,
  queryClient
) => {
  try {
    let updatedCard = await buildCardDetails(
      { ...card },
      false,
      userRestrictedRole,
      userRestrictedEcosystemt,
      restrictedProductSquad,
      priorityCustomers
    );

    const params = [
      updatedCard?.advance?.measure,
      updatedCard?.advance?.dimension,
      updatedCard?.appId,
      updatedCard?.advance?.chartType,
      undefined,
    ];

    const queryKey = [QUERY_KEY.TrendsAnalytics, ...params];

    const res = await queryClient.ensureQueryData({
      queryKey: queryKey,
      queryFn: () =>
        trackPromise(getMultiDimensionChartData(...params), updatedCard.cardId),
    });

    return {
      ...updatedCard,
      chartData: res?.data[NUMBER_ZERO],
      chartType: updatedCard?.advance?.chartType,
    };
  } catch (error) {
    console.log(error.message);
    return card;
  }
};

export const updateCardPositions = async (payload) => {
  const updatePositions = async () => {
    const response = await axiosDBClient.patch(`v2/views/configure/`, {
      ...payload,
    });

    if (response.data.error) {
      throw new Error('Could not update positions!');
    }

    return response.data;
  };

  try {
    const data = await updatePositions();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};
export const getTilesToReorder = async (page, viewId) => {
  const getTiles = async () => {
    const response = await axiosDBClient.get(`v2/view-list/reorder/tiles`, {
      params: { page, viewId },
    });
    if (response.data.error) {
      throw new Error('Could not update positions!');
    }

    return response?.data?.result;
  };

  try {
    const data = await getTiles();
    return data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getReleaseData = async (roleId, unixId) => {
  try {
    const response = await axiosDBClient.get(`release-notes`, {
      params: { roleId, unixId },
    });
    if (response.error) {
      throw new Error('NO release Data');
    }
    return response?.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const logoutSSO = async (id) => {
  if (id !== undefined && id !== '') {
    try {
      const payload = { id };
      return await axiosDBClient.post('logout', {
        ...payload,
      });
    } catch (error) {
      console.log(error.message);
      return error.message;
    }
  }
};

export const updateReleaseData = async (roleId, unixId) => {
  try {
    const body = { roleId: roleId, unixId: unixId };
    const response = await axiosDBClient.put(`release-notes`, {
      ...body,
    });
    if (response.error) {
      throw new Error('NO release Data');
    }
    return response.data.result;
  } catch (error) {
    console.log(error.message);
  }
};
export const getSystemAlertsData = async (roleId) => {
  try {
    const response = await axiosDBClient.get(
      `/notifications/system-alert?roleId=${roleId}`
    );
    return response?.data?.result;
  } catch (error) {
    console.log(error);
  }
};

export const getNotificationsData = async (unixId, roleId) => {
  try {
    const response = await axiosDBClient.get(
      `/notifications/user?unixId=${unixId}&roleId=${roleId}`
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

export const downloadTileData = async (kpiTtitle, payload) => {
  try {
    const res = await axiosQlikClient.post(`hco/export`, payload, {
      responseType: 'blob',
    });

    const FileDownload = require('js-file-download');
    const response = FileDownload(res?.data, `${kpiTtitle}-Data.xlsx`);
    return response;
  } catch (error) {
    console.log(error);
    throw new Error('Could not download data!');
  }
};

export const getFavoriteData = async (unixId, roleId) => {
  try {
    const response = await axiosDBClient.get(
      `/report/getReports?unixId=${unixId}&roleId=${roleId}`
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};
